import { createContext, useContext } from 'react';
import type { AnalyticsWindow } from '@/types/dashboard.types';

// Server-defined chart window, shared with every BarChart so charts render the
// exact range the server queried rather than recomputing "today" from the
// browser clock (which drifts a day off in timezones behind UTC, dropping the
// leftmost bar). Null only while data is loading.
export const AnalyticsWindowContext = createContext<AnalyticsWindow | null>(
  null,
);

export const useAnalyticsWindow = () => useContext(AnalyticsWindowContext);
